import { Routes, Route, Navigate } from 'react-router-dom';
import { PrivateRoute, RoleRoute } from 'components/shared/PermissionGuard';
import { useAuth } from 'context/AuthContext';
import { canAccessSection, getDefaultPath } from 'permissions';
import MainLayout from 'components/layout/MainLayout';

// Auth
import Login from 'app/Login';
import ForceChangePassword from 'app/auth/ForceChangePassword';
import ActivationPage from 'app/auth/ActivationPage';
import NotFound from 'app/NotFound';

// Command Center
import CommandCenterPage from 'app/dashboard/command-center/CommandCenterPage';

// Monitoring
import SitesOverview from 'app/dashboard/monitoring/SitesOverview';

// Incidents
import IncidentsPage from 'app/dashboard/incidents/IncidentsPage';

// Agents
import AgentsPage from 'app/dashboard/agents/AgentsPage';

// Patrols
import PatrolsPage from 'app/dashboard/patrols/PatrolsPage';
import ControleurPage from 'app/dashboard/patrols/ControleurPage';

// Equipment
import EquipmentPage from 'app/dashboard/equipment/EquipmentPage';
import VehiclesPage from 'app/dashboard/equipment/VehiclesPage';

// Cynophile
import CynophilePage from 'app/dashboard/operations/CynophilePage';
import EtatsPersonnelPage from 'app/dashboard/enterprise/hr/EtatsPersonnelPage';

// Enterprise — HR
import AgentsRHPage from 'app/dashboard/enterprise/hr/AgentsRHPage';
import ClassificationMassePage from 'app/dashboard/enterprise/hr/ClassificationMassePage';
import RevisionGrillePage from 'app/dashboard/enterprise/hr/RevisionGrillePage';
import ContractsPage from 'app/dashboard/enterprise/hr/ContractsPage';
import TrainingPage from 'app/dashboard/enterprise/hr/TrainingPage';
import PointagePage from 'app/dashboard/enterprise/hr/PointagePage';
import CongesPage from 'app/dashboard/enterprise/hr/CongesPage';
import PayrollPage from 'app/dashboard/enterprise/hr/PayrollPage';
import PlanningPage from 'app/dashboard/enterprise/hr/PlanningPage';
import ParametragePaiePage from 'app/dashboard/enterprise/hr/ParametragePaiePage';
import PostesPage from 'app/dashboard/enterprise/hr/PostesPage';
import OrganigramPage from 'app/dashboard/enterprise/hr/OrganigramPage';

// Enterprise — Finance
import InvoicesPage from 'app/dashboard/enterprise/finance/InvoicesPage';
import QuotesPage from 'app/dashboard/enterprise/finance/QuotesPage';
import ExpensesPage from 'app/dashboard/enterprise/finance/ExpensesPage';
import EncaissementsPage from 'app/dashboard/enterprise/finance/EncaissementsPage';
import TresoreriePage from 'app/dashboard/enterprise/finance/TresoreriePage';
import PrevisionsTresoreriePage from 'app/dashboard/enterprise/finance/PrevisionsTresoreriePage';
import FournisseursPage from 'app/dashboard/enterprise/finance/FournisseursPage';
import PaieSocialePage from 'app/dashboard/enterprise/finance/PaieSocialePage';

// Enterprise — Accounting
import IncomeStatement from 'app/dashboard/enterprise/accounting/IncomeStatement';
import ExportPage from 'app/dashboard/enterprise/accounting/ExportPage';
import BilanPage from 'app/dashboard/enterprise/accounting/BilanPage';
import FluxTresoreriePage from 'app/dashboard/enterprise/accounting/FluxTresoreriePage';
import RatiosPage from 'app/dashboard/enterprise/accounting/RatiosPage';
import BudgetPage from 'app/dashboard/enterprise/accounting/BudgetPage';
import PlanComptablePage from 'app/dashboard/enterprise/accounting/PlanComptablePage';
import JournauxPage from 'app/dashboard/enterprise/accounting/JournauxPage';
import GrandLivrePage from 'app/dashboard/enterprise/accounting/GrandLivrePage';
import BalancePage from 'app/dashboard/enterprise/accounting/BalancePage';
import ImmobilisationsPage from 'app/dashboard/enterprise/accounting/ImmobilisationsPage';
import ExercicesPage from 'app/dashboard/enterprise/accounting/ExercicesPage';
import ExportFECPage from 'app/dashboard/enterprise/accounting/ExportFECPage';

// Enterprise — CRM
import ClientsPage from 'app/dashboard/enterprise/crm/ClientsPage';
import ProspectionPage from 'app/dashboard/enterprise/crm/ProspectionPage';

// Enterprise — TSV
import TSVDashboard from 'app/dashboard/enterprise/tsv/TSVDashboard';
import CataloguePage from 'app/dashboard/enterprise/tsv/CataloguePage';
import JournalVeillePage from 'app/dashboard/enterprise/tsv/JournalVeillePage';
import AlarmesPage from 'app/dashboard/enterprise/tsv/AlarmesPage';

// Enterprise — Audit & Déploiement
import NouvelAudit from 'app/dashboard/enterprise/audit/NouvelAudit';
import AuditsPage from 'app/dashboard/enterprise/audit/AuditsPage';
import PlanPrevention from 'app/dashboard/enterprise/audit/PlanPrevention';
import PlansPage from 'app/dashboard/enterprise/audit/PlansPage';
import DechargesPage from 'app/dashboard/enterprise/audit/DechargesPage';

// Enterprise — Contrats Prestation
import ContratPrestationPage from 'app/dashboard/enterprise/contracts/ContratPrestationPage';

// Enterprise — Commerce
import OffresPage from 'app/dashboard/enterprise/commerce/OffresPage';
import MargeDashboard from 'app/dashboard/enterprise/commerce/MargeDashboard';

// Enterprise — Assistanat Direction
import AgendaDG from 'app/dashboard/enterprise/assistanat/AgendaDG';
import Courriers from 'app/dashboard/enterprise/assistanat/Courriers';
import ComptesRendus from 'app/dashboard/enterprise/assistanat/ComptesRendus';
import Archivage from 'app/dashboard/enterprise/assistanat/Archivage';

// Intelligence IA
import AssistantPage from 'app/dashboard/ia/AssistantPage';
import AlertesPredictivesPage from 'app/dashboard/ia/AlertesPredictivesPage';
import RapportIAPage from 'app/dashboard/ia/RapportIAPage';

// Salle de Commandement
import CommandementHub from 'app/commandement/CommandementHub';
import CommandementCarte from 'app/commandement/CommandementCarte';
import CommandementIncidents from 'app/commandement/CommandementIncidents';
import CommandementAgents from 'app/commandement/CommandementAgents';

// Admin
import ImportPage from 'app/dashboard/admin/ImportPage';
import UsersPage from 'app/dashboard/admin/UsersPage';
import ValidationsPage from 'app/dashboard/admin/ValidationsPage';
import LogsAuditPage from 'app/dashboard/admin/LogsAuditPage';
import ParametresPage from 'app/dashboard/admin/ParametresPage';
import Profil from 'app/dashboard/admin/Profil';

// Super Admin
import SuperAdminLogin from 'app/superadmin/SuperAdminLogin';
import SuperAdminDashboard from 'app/superadmin/SuperAdminDashboard';
import SuperAdminTenants from 'app/superadmin/SuperAdminTenants';
import SuperAdminFacturation from 'app/superadmin/SuperAdminFacturation';
import SuperAdminFacturesHistorique from 'app/superadmin/SuperAdminFacturesHistorique';
import SuperAdminTarifs from 'app/superadmin/SuperAdminTarifs';
import SuperAdminReferentielPays from 'app/superadmin/SuperAdminReferentielPays';
import LegalPage from 'app/superadmin/LegalPage';
import SuperAdminCRM from 'app/superadmin/SuperAdminCRM';
import SuperAdminIA from 'app/superadmin/SuperAdminIA';
import SuperAdminOnboarding from 'app/superadmin/SuperAdminOnboarding';
import SuperAdminDemandes from 'app/superadmin/SuperAdminDemandes';
import SuperAdminLayout from 'app/superadmin/SuperAdminLayout';

// Public
import LandingPage from 'app/public/LandingPage';
import MentionsLegales from 'app/public/MentionsLegales';
import Confidentialite from 'app/public/Confidentialite';
import QuiSommesNous from 'app/public/QuiSommesNous';
import FaqPage from 'app/public/FaqPage';

function SmartHome() {
  const { user } = useAuth();
  const roles = user?.roles || (user?.role ? [user.role] : []);
  if (canAccessSection(roles, 'command-center')) return <CommandCenterPage />;
  const dest = getDefaultPath(roles);
  return dest !== '/' ? <Navigate to={dest} replace /> : <CommandCenterPage />;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/force-change-password" element={<ForceChangePassword />} />
      {/* ⚠️ PUBLIQUE PAR NÉCESSITÉ, et c'est volontaire : son porteur n'a pas
          encore de mot de passe, donc il ne peut pas être authentifié. Le jeton
          du lien EST l'autorisation, et il est à usage unique, horodaté et
          révocable (`public.activations_compte`).
          ⓘ Cette page n'existait pas : la route serveur vivait depuis le 17/09
            et aucun écran ne pouvait ouvrir un lien — mesuré le 12/10 sur le
            bundle servi (0 occurrence de « activation/ »). */}
      <Route path="/activation/:jeton" element={<ActivationPage />} />

      {/* Super Admin (standalone, avant PrivateRoute) */}
      <Route path="/super-admin/login" element={<SuperAdminLogin />} />
      <Route path="/super-admin" element={<SuperAdminLayout />}>
        <Route index element={<SuperAdminDashboard />} />
        <Route path="tenants" element={<SuperAdminTenants />} />
        <Route path="facturation" element={<SuperAdminFacturation />} />
        <Route path="facturation/historique" element={<SuperAdminFacturesHistorique />} />
        <Route path="tarifs" element={<SuperAdminTarifs />} />
        {/* Le message d'erreur de creation de tenant renvoie ici depuis le 02/09 :
            jusqu'au 03/09 la page n'existait pas. Lien mort ferme. */}
        <Route path="referentiel-pays" element={<SuperAdminReferentielPays />} />
        <Route path="clients-suivi" element={<SuperAdminCRM />} />
        <Route path="demandes" element={<SuperAdminDemandes />} />
        <Route path="legal" element={<LegalPage />} />
        <Route path="ia-config" element={<SuperAdminIA />} />
        <Route path="onboarding" element={<SuperAdminOnboarding />} />
      </Route>

      {/* Public — Vitrine */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/vitrine" element={<LandingPage />} />
      <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/public/gss360" element={<LandingPage />} />
      <Route path="/legal" element={<LegalPage />} />

      {/* Salle de Commandement (plein ecran, hors MainLayout) */}
      <Route path="/commandement" element={<PrivateRoute><RoleRoute path="/commandement"><CommandementHub /></RoleRoute></PrivateRoute>} />
      <Route path="/commandement/carte" element={<PrivateRoute><RoleRoute path="/commandement"><CommandementCarte /></RoleRoute></PrivateRoute>} />
      <Route path="/commandement/incidents" element={<PrivateRoute><RoleRoute path="/commandement"><CommandementIncidents /></RoleRoute></PrivateRoute>} />
      <Route path="/commandement/agents" element={<PrivateRoute><RoleRoute path="/commandement"><CommandementAgents /></RoleRoute></PrivateRoute>} />

      <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        {/* Dashboard home — redirige selon le rôle */}
        <Route index element={<SmartHome />} />

        {/* Centre de commandement */}
        <Route path="sites" element={<RoleRoute path="/sites"><SitesOverview /></RoleRoute>} />
        <Route path="incidents" element={<RoleRoute path="/incidents"><IncidentsPage /></RoleRoute>} />

        {/* Operations terrain */}
        <Route path="agents" element={<RoleRoute path="/agents"><AgentsPage /></RoleRoute>} />
        <Route path="rondes" element={<RoleRoute path="/rondes"><PatrolsPage /></RoleRoute>} />
        <Route path="controleur" element={<RoleRoute path="/controleur"><ControleurPage /></RoleRoute>} />

        {/* Equipements & Vehicules */}
        <Route path="vehicules" element={<RoleRoute path="/vehicules"><VehiclesPage /></RoleRoute>} />
        <Route path="equipements" element={<RoleRoute path="/equipements"><EquipmentPage /></RoleRoute>} />
        <Route path="cynophile" element={<RoleRoute path="/cynophile"><CynophilePage /></RoleRoute>} />
        <Route path="etats-personnel" element={<RoleRoute path="/etats-personnel"><EtatsPersonnelPage /></RoleRoute>} />

        {/* Entreprise — RH */}
        <Route path="agents-rh" element={<RoleRoute path="/agents-rh"><AgentsRHPage /></RoleRoute>} />
        <Route path="classement-agents" element={<RoleRoute path="/classement-agents"><ClassificationMassePage /></RoleRoute>} />
        {/* ⚠️ Le garde de route et le menu lisent LA MEME table (`permissions.js`
            via `canAccessNav`). Les roles de l'ecran sont donc declares UNE fois,
            et ils doivent valoir ceux de `canRevisser` cote API — sinon le menu
            offrirait un ecran que le serveur refuse. */}
        <Route path="revision-grille" element={<RoleRoute path="/revision-grille"><RevisionGrillePage /></RoleRoute>} />
        <Route path="contrats-travail" element={<RoleRoute path="/contrats-travail"><ContractsPage /></RoleRoute>} />
        <Route path="formations" element={<RoleRoute path="/formations"><TrainingPage /></RoleRoute>} />
        <Route path="pointage" element={<RoleRoute path="/pointage"><PointagePage /></RoleRoute>} />
        <Route path="conges" element={<RoleRoute path="/conges"><CongesPage /></RoleRoute>} />
        <Route path="paie" element={<RoleRoute path="/paie"><PayrollPage /></RoleRoute>} />
        {/* ⓘ Le garde de route ouvre a `dg`, `admin` et `rh` — les trois qui
            LISENT. L'ecriture est reservee a `dg` et `admin`, et c'est l'ECRAN
            qui n'affiche pas les boutons : un garde de route ne sait pas
            distinguer lire d'ecrire, et la route serveur reste l'autorite. */}
        <Route path="parametrage-paie" element={<RoleRoute path="/parametrage-paie"><ParametragePaiePage /></RoleRoute>} />
        <Route path="planning" element={<RoleRoute path="/planning"><PlanningPage /></RoleRoute>} />
        {/* ⛔ LA ROUTE `personnel-admin` A ETE RETIREE LE 18/10/2026 avec son
            entree de menu. L ecran lisait `gladiator_sec.personnel_admin`, table
            MORTE (zero ligne en production, mesure le 18/10). *Une entree
            retiree du menu dont la route repond encore est une entree qu on
            croit retiree.* Le besoin passe par le filtre « Toutes populations »
            de « Fiches du personnel ». Le retrait de la TABLE est un lot a
            part, apres preuve de 0 lecture. */}
        <Route path="postes" element={<RoleRoute path="/postes"><PostesPage /></RoleRoute>} />
        <Route path="organigramme" element={<RoleRoute path="/organigramme"><OrganigramPage /></RoleRoute>} />

        {/* Entreprise — Finance (Commercial) */}
        <Route path="facturation" element={<RoleRoute path="/facturation"><InvoicesPage /></RoleRoute>} />
        <Route path="devis" element={<RoleRoute path="/devis"><QuotesPage /></RoleRoute>} />
        <Route path="encaissements" element={<RoleRoute path="/encaissements"><EncaissementsPage /></RoleRoute>} />

        {/* Entreprise — Finance (Tresorerie) */}
        <Route path="tresorerie" element={<RoleRoute path="/tresorerie"><TresoreriePage /></RoleRoute>} />
        <Route path="previsions-tresorerie" element={<RoleRoute path="/previsions-tresorerie"><PrevisionsTresoreriePage /></RoleRoute>} />

        {/* Entreprise — Finance (Charges) */}
        <Route path="fournisseurs" element={<RoleRoute path="/fournisseurs"><FournisseursPage /></RoleRoute>} />
        <Route path="charges" element={<RoleRoute path="/charges"><ExpensesPage /></RoleRoute>} />
        <Route path="paie-sociale" element={<RoleRoute path="/paie-sociale"><PaieSocialePage /></RoleRoute>} />

        {/* Entreprise — Comptabilite Generale (SYSCOHADA) */}
        <Route path="plan-comptable" element={<RoleRoute path="/plan-comptable"><PlanComptablePage /></RoleRoute>} />
        <Route path="journaux" element={<RoleRoute path="/journaux"><JournauxPage /></RoleRoute>} />
        <Route path="grand-livre" element={<RoleRoute path="/grand-livre"><GrandLivrePage /></RoleRoute>} />
        <Route path="balance" element={<RoleRoute path="/balance"><BalancePage /></RoleRoute>} />
        <Route path="immobilisations" element={<RoleRoute path="/immobilisations"><ImmobilisationsPage /></RoleRoute>} />
        <Route path="exercices" element={<RoleRoute path="/exercices"><ExercicesPage /></RoleRoute>} />
        <Route path="export-fec" element={<RoleRoute path="/export-fec"><ExportFECPage /></RoleRoute>} />

        {/* Entreprise — Comptabilite (Analyse) */}
        <Route path="compte-resultat" element={<RoleRoute path="/compte-resultat"><IncomeStatement /></RoleRoute>} />
        <Route path="bilan" element={<RoleRoute path="/bilan"><BilanPage /></RoleRoute>} />
        <Route path="flux-tresorerie" element={<RoleRoute path="/flux-tresorerie"><FluxTresoreriePage /></RoleRoute>} />
        <Route path="ratios" element={<RoleRoute path="/ratios"><RatiosPage /></RoleRoute>} />
        <Route path="budget" element={<RoleRoute path="/budget"><BudgetPage /></RoleRoute>} />
        <Route path="export-comptable" element={<RoleRoute path="/export-comptable"><ExportPage /></RoleRoute>} />

        {/* Entreprise — CRM */}
        <Route path="clients" element={<RoleRoute path="/clients"><ClientsPage /></RoleRoute>} />
        <Route path="commerce" element={<RoleRoute path="/commerce"><ProspectionPage /></RoleRoute>} />

        {/* Entreprise — Commerce & TSV */}
        <Route path="catalogue" element={<RoleRoute path="/catalogue"><CataloguePage /></RoleRoute>} />
        <Route path="telesurveillance" element={<RoleRoute path="/telesurveillance"><TSVDashboard /></RoleRoute>} />
        <Route path="journal-veille" element={<RoleRoute path="/journal-veille"><JournalVeillePage /></RoleRoute>} />
        <Route path="alarmes" element={<RoleRoute path="/alarmes"><AlarmesPage /></RoleRoute>} />

        {/* Audit & Déploiement */}
        <Route path="audit/nouveau" element={<RoleRoute path="/audit/nouveau"><NouvelAudit /></RoleRoute>} />
        <Route path="audit/liste" element={<RoleRoute path="/audit/liste"><AuditsPage /></RoleRoute>} />
        <Route path="audit/plans" element={<RoleRoute path="/audit/plans"><PlansPage /></RoleRoute>} />
        <Route path="audit/:id/plan" element={<RoleRoute path="/audit/plans"><PlanPrevention /></RoleRoute>} />
        <Route path="audit/decharges" element={<RoleRoute path="/audit/decharges"><DechargesPage /></RoleRoute>} />

        {/* Contrats Prestation & Offres */}
        <Route path="contrats-prestation" element={<RoleRoute path="/contrats-prestation"><ContratPrestationPage /></RoleRoute>} />
        <Route path="offres" element={<RoleRoute path="/offres"><OffresPage /></RoleRoute>} />
        <Route path="marge-dg" element={<RoleRoute path="/marge-dg"><MargeDashboard /></RoleRoute>} />

        {/* Assistanat Direction */}
        <Route path="agenda-dg" element={<RoleRoute path="/agenda-dg"><AgendaDG /></RoleRoute>} />
        <Route path="courriers" element={<RoleRoute path="/courriers"><Courriers /></RoleRoute>} />
        <Route path="comptes-rendus" element={<RoleRoute path="/comptes-rendus"><ComptesRendus /></RoleRoute>} />
        <Route path="archivage" element={<RoleRoute path="/archivage"><Archivage /></RoleRoute>} />

        {/* Intelligence IA */}
        <Route path="ia/assistant" element={<RoleRoute path="/ia/assistant"><AssistantPage /></RoleRoute>} />
        <Route path="ia/alertes" element={<RoleRoute path="/ia/alertes"><AlertesPredictivesPage /></RoleRoute>} />
        <Route path="ia/rapport" element={<RoleRoute path="/ia/rapport"><RapportIAPage /></RoleRoute>} />

        {/* Administration */}
        <Route path="utilisateurs" element={<RoleRoute path="/utilisateurs"><UsersPage /></RoleRoute>} />
        <Route path="validations" element={<RoleRoute path="/validations"><ValidationsPage /></RoleRoute>} />
        <Route path="logs-audit" element={<RoleRoute path="/logs-audit"><LogsAuditPage /></RoleRoute>} />
        <Route path="parametres" element={<RoleRoute path="/parametres"><ParametresPage /></RoleRoute>} />
        <Route path="import-donnees" element={<RoleRoute path="/import-donnees"><ImportPage /></RoleRoute>} />
        <Route path="profil" element={<Profil />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
